"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Input = _interopRequireDefault(require("../Input"));
var _Button = _interopRequireDefault(require("../Button"));
var _withFormat = require("../../hocs/withFormat");
var _userflow = require("../../utils/userflow");
var _excluded = ["maxLength", "value", "placeholder", "onChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SearchIcon = function SearchIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none",
    stroke: "#007AFF",
    d: "M12.435 1.075L2.358 11.152l-1.203 3.18 3.334-1.068L14.556 3.197l-2.121-2.122z"
  }));
};
SearchIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
var inputPropTypes = _Input["default"].propTypes,
  inputDefaultProps = _Input["default"].defaultProps;
var PriceField = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var maxLength = _ref.maxLength,
    initialValue = _ref.value,
    initialPlaceholder = _ref.placeholder,
    onChange = _ref.onChange,
    inputProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var stringifiedValue = initialValue && String(initialValue) || null;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isFocus = _useState2[0],
    setFocus = _useState2[1];
  var _useState3 = (0, _react.useState)(stringifiedValue),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    width = _useState6[0],
    setWidth = _useState6[1];
  var isFilled = !(0, _isEmpty2["default"])(value);
  (0, _react.useEffect)(function () {
    setValue(stringifiedValue);
  }, [initialValue]);
  var placeholder = {
    __html: (0, _isEmpty2["default"])(value) ? initialPlaceholder : (0, _userflow.formatDecimal)(value)
  };
  var placeholderRef = (0, _react.useRef)();
  var updateWidth = (0, _react.useCallback)(function () {
    var node = placeholderRef && placeholderRef.current;
    if (node) {
      setWidth(node.offsetWidth + 1);
    }
    window.requestAnimationFrame(updateWidth);
  }, [placeholderRef, width]);
  (0, _react.useEffect)(function () {
    updateWidth();
  }, [placeholderRef]);
  var handleOnChange = (0, _react.useCallback)(function (newValue) {
    setValue(newValue);
    onChange(newValue);
  });
  return /*#__PURE__*/_react["default"].createElement(StyledField, {
    functional: true,
    isFocus: isFocus,
    isFilled: isFilled,
    onClick: function onClick() {
      return setFocus(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(StyledPlaceholder, {
    dangerouslySetInnerHTML: placeholder,
    ref: placeholderRef
  }), isFocus && /*#__PURE__*/_react["default"].createElement(StyledInput, (0, _extends2["default"])({}, inputProps, {
    autoFocus: isFocus,
    maxLength: maxLength,
    onBlur: function onBlur() {
      return setFocus(false);
    },
    onChange: handleOnChange,
    onKeyUp: updateWidth,
    placeholder: initialPlaceholder,
    style: {
      width: width
    },
    type: "tel",
    value: value
  })), isFilled && '₽', !isFocus && /*#__PURE__*/_react["default"].createElement(StyledEditIcon, null));
});
PriceField.displayName = 'PriceField';
var StyledInput = (0, _styledComponents["default"])((0, _withFormat.withDecimalFormat)(_Input["default"])).withConfig({
  displayName: "PriceField__StyledInput",
  componentId: "sc-172naig-0"
})(["background:none;border:none;outline:none;position:absolute;padding:0;outline-offset:0;z-index:1;color:black;::placeholder{color:#919499;}"]);
var StyledPlaceholder = _styledComponents["default"].span.withConfig({
  displayName: "PriceField__StyledPlaceholder",
  componentId: "sc-172naig-1"
})(["width:max-content;padding:0;margin-right:2px;"]);
var StyledEditIcon = (0, _styledComponents["default"])(SearchIcon).withConfig({
  displayName: "PriceField__StyledEditIcon",
  componentId: "sc-172naig-2"
})(["height:16px;margin-left:9px;width:16px;display:none;margin-top:6px;"]);
var StyledField = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "PriceField__StyledField",
  componentId: "sc-172naig-3"
})(["font-size:14px;position:relative;display:flex;height:25px;line-height:25px;outline:none;", ""], function (_ref2) {
  var theme = _ref2.theme,
    isFocus = _ref2.isFocus,
    isFilled = _ref2.isFilled;
  return "\n    ".concat(StyledPlaceholder, " {\n      opacity: ").concat(isFocus ? 0 : 1, ";\n      color: ").concat(isFilled ? theme.colors.black : theme.colors.greyLight, "\n    }\n\n    :hover {\n      color: ").concat(isFocus ? theme.colors.black : theme.colors.greyLight, ";\n\n      ").concat(StyledPlaceholder, " {\n        color: ").concat(theme.colors.blue, ";\n      }\n\n      ").concat(StyledEditIcon, " {\n        display: block;\n      }\n    }\n  ");
});
PriceField.propTypes = _objectSpread(_objectSpread({}, inputPropTypes), {}, {
  maxLength: _propTypes["default"].number
});
PriceField.defaultProps = _objectSpread(_objectSpread({}, inputDefaultProps), {}, {
  maxLength: null
});
var _default = exports["default"] = PriceField;